import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'

export const container = css`
  background-color: var(--colorScheme-bgMinor, ${cssTheme.colors.warmGray[125]});
  border-radius: 16px;
  min-block-size: 56px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  outline: none !important;
`

export const textLeft = css`
  text-align: left;
`

export const textCenter = css`
  text-align: center;
`

export const textRight = css`
  text-align: right;
`
